import { DES_AK_TENANT_TOKEN, DES_EVO_TENANT_TOKEN, DES_EVO_USER_TOKEN, DES_I_AM_TOKEN } from "@jti/fe-common";

import { Rest } from "../Rest";

import type { Endpoints, EvoEndpoints } from "./CasEndpoints";
import { EndpointPlaceholders } from "./CasEndpoints";
import { handleAddPlusToPhone } from "./utils";

type PlaceholdersOptions = Partial<Record<keyof typeof EndpointPlaceholders, string>>;
export class CasBaseApi extends Rest {
  name = "CasBaseApi";
  public readonly userId?: string;
  constructor(
    baseUrl: string,
    protected tenantToken: string,
    protected ciamToken?: string,
    userId?: string
  ) {
    super(baseUrl);
    this.setCommonHeader(DES_AK_TENANT_TOKEN, this.tenantToken);
    this.setCommonHeader(DES_EVO_TENANT_TOKEN, this.tenantToken);
    this.userId = userId;
    if (this.ciamToken) {
      this.setCommonHeader(DES_I_AM_TOKEN, this.ciamToken);
      this.setCommonHeader(DES_EVO_USER_TOKEN, this.ciamToken);
    }
  }

  protected formatEndpointUrl(path: Endpoints | EvoEndpoints | string, replacers: PlaceholdersOptions): string {
    return Object.entries(replacers).reduce<string>((acc, [key, value]) => {
      if (key in EndpointPlaceholders) {
        const replacer = EndpointPlaceholders[key as keyof typeof EndpointPlaceholders];
        return acc.replace(replacer, value);
      }
      return acc;
    }, path);
  }

  protected replaceUuid(path: string, uuid?: string): string {
    return this.formatEndpointUrl(path, { UUID: uuid ?? this.userId });
  }

  protected replacePhone(path: string, phone: string): string {
    return this.formatEndpointUrl(path, { PHONE: this.isEvo ? handleAddPlusToPhone(phone) : phone });
  }

  protected replaceEmail(path: string, email: string): string {
    return this.formatEndpointUrl(path, { EMAIL: email });
  }

  protected replaceUserToken(path: string, token: string): string {
    return this.formatEndpointUrl(path, { USER_TOKEN: token });
  }

  protected replaceAddressId(path: string, addressId: string): string {
    return this.formatEndpointUrl(path, { ADDRESS_ID: addressId });
  }
}
